<template>
  <div>
    <mdb-modal removeBackdrop centered @close="$store.commit('clearCurrentModal')" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Can’t find what you're looking for?</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          The Test Studio Finder does not display the entire isi Network at this
          point.
          <br />
          <br />Please let us now what you are looking for and we will identify
          a suitable Test Facility for your needs.
        </p>
        <form v-on:submit.prevent>
          <div class="grey-text">
            <mdb-input
              class="mt-4"
              type="text"
              label="Where do you want to test?"
              icon="globe-europe"
              v-model="location"
              outline
            />
            <mdb-select
              class="mt-4"
              v-model="options.testTypesMdb"
              label="Test type"
              :visibleOptions="parseInt(10)"
              outline
            />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn class="mt-4" color="isi" @click="sendLocationRequest"
              >CONTACT US</mdb-btn
            >
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  components: {
    ValidationInfo,
  },
  data() {
    return {
      location: "",
      validationInfo: "",
    };
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    sendLocationRequest() {
      if (!this.location) {
        this.validationInfo = "Please type in the desired location(s).";
        return;
      }

      this.validationInfo = "";

      this.$http({
        method: "post",
        url: "/api/UserAction/RequestLocation",
        data: {
          testType: this.options.testTypesMdb.find((x) => x.selected).value,
          message: this.location,
        },
      }).then(() => {
        this.$store.commit("setCurrentModal", {
          type: "GeneralInfoModal",
          options: {
            title: "Request sent",
            content: "Thank you for sending your request.",
          },
        });
      });
    },
  },
};
</script>

<style scoped>
#footer-text {
  width: 100%;
  text-align: center;
}
</style>